import { z } from 'zod';

import {
  PartOfSpeechEnEnum,
  LanguageEnum,
  PartOfSpeechRuEnum,
} from '../../enums';

export const ExampleSchema = z.object({
  sentence: z.string().min(1, 'Example sentence cannot be empty'),
  translation: z.string().min(1, 'Example translation cannot be empty'),
});

export const BaseTranslationDetailSchema = z.object({
  example: ExampleSchema.nullable().optional(),
  grammar: z.string().nullable().optional(),
  translation: z.string().min(1, 'Translation cannot be empty'),
  usage: z.string().nullable().optional(),
});

export const EnglishTranslationDetailSchema =
  BaseTranslationDetailSchema.extend({
    partOfSpeech: z.nativeEnum(PartOfSpeechEnEnum).nullable().optional(),
  });

export const RussianTranslationDetailSchema =
  BaseTranslationDetailSchema.extend({
    partOfSpeech: z.nativeEnum(PartOfSpeechRuEnum).nullable().optional(),
  });

export const TranslationsSchema = z
  .object({
    [LanguageEnum.EN]: z.array(EnglishTranslationDetailSchema).optional(),
    [LanguageEnum.RU]: z.array(RussianTranslationDetailSchema).optional(),
  })
  .refine(
    (data) => {
      return !!(
        (data[LanguageEnum.EN] && data[LanguageEnum.EN].length > 0) ||
        (data[LanguageEnum.RU] && data[LanguageEnum.RU].length > 0)
      );
    },
    {
      message: 'Translations must include at least one entry for EN or RU',
    },
  );

export type IExampleDto = z.infer<typeof ExampleSchema>;
export type IBaseTranslationDetailDto = z.infer<
  typeof BaseTranslationDetailSchema
>;
export type IEnglishTranslationDetailDto = z.infer<
  typeof EnglishTranslationDetailSchema
>;
export type IRussianTranslationDetailDto = z.infer<
  typeof RussianTranslationDetailSchema
>;
export type ITranslationsDto = z.infer<typeof TranslationsSchema>;
